import { useRecoDialog } from '@/core/composables/useRecoDialog.ts';
import ImportStudyDialog from '@/modules/recruitment/components/ImportStudyDialog/ImportStudyDialog.vue';

export const useImportStudyDialog = () => {
  const dialog = useRecoDialog();

  const open = () => {
    dialog.open(ImportStudyDialog, {});
  };

  return {
    open,
  };
};
